import { IsNumber, IsOptional, IsString, IsArray } from "class-validator";
import { Expose, Type } from "class-transformer";

export class DocumentForReceipt {
  @IsNumber()
  @Expose()
  documentType!: number;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsString()
  @Expose()
  comment!: string;
  @IsArray()
  @Expose()
  @Type(() => OrderItemReceipt)
  orderItems!: Array<OrderItemReceipt>;
}

export class OrderItemReceipt {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentId!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  netInCurrency!: number;
  @IsString()
  @Expose()
  vatRate!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @IsOptional()
  @Expose()
  documentItemOrdinal!: number | null;
}

export class OrderItemReceiptTemp extends OrderItemReceipt {
  @IsNumber()
  @Expose()
  grossInCurrencyTemp!: number;
  @IsNumber()
  @Expose()
  netInCurrencyTemp!: number;

  constructor(val: OrderItemReceipt) {
    super();
    this.id = val.id;
    this.documentId = val.documentId;
    this.name = val.name;
    this.grossInCurrency = val.grossInCurrency;
    this.netInCurrency = val.netInCurrency;
    this.vatRate = val.vatRate;
    this.currency = val.currency;
    this.documentItemOrdinal = val.documentItemOrdinal;
    this.grossInCurrencyTemp = val.grossInCurrency;
    this.netInCurrencyTemp = val.netInCurrency;
  }
}
